import { Component, OnInit, Inject } from '@angular/core';
import { environment, ConstVariable } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { LookupInfo } from '../../model/lookup.model';
import { GlobalService } from '../../service/global.service';
import { TokenService } from '../../service/token.service';
import { PositionLevelInfo } from '../../model/PositionManagementInfo.model';

@Component({
  selector: 'app-position-level',
  templateUrl: './position-level.component.html',
  styleUrls: ['./position-level.component.css']
})
export class PositionLevelComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;
 
  //Master Model
  ListStatus: LookupInfo[] = [];
  ListMasterManagement: PositionLevelInfo[] = [];
  positionInfo: PositionLevelInfo = new PositionLevelInfo;

  //Search
  isSearchSubmitted: boolean = false;
  txtSchMasterName: string;
  txtSchMasterCode: string;
  ddlSchMasterStatus: string = "";
  
  //Form variable
  masterForm: FormGroup;
  IsDuplicateCode: boolean;
  
  //Pagination
  indexNo: number = 0;
  currentPageNumber: number = 1;
  totalMaster: number = 0;
  totalPages: number = 0;
  pageSize: number;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;

  
  /************************* End Variables ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    //Init data
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSizeMedium;
    this._EmpCode = localStorage.getItem("EmpCode");
    this.ddlSchMasterStatus = 'Y'

    //Load init data
    this.LoadLookupType("MASTERSTATUS")
      .then((data) => {
        this.ListStatus = data;
      });
    
    this.LoadMasterList().then((data) => {
      this.ListMasterManagement = data;
    });
    this.LoadCountMasterList();

    //Declare form
    this.masterForm = new FormGroup({
      MasterCode: new FormControl(this.positionInfo.PositionLevel, [Validators.required]),
      MasterName: new FormControl(this.positionInfo.PositionLevelName, [Validators.required]),
      MasterStatus: new FormControl(this.positionInfo.FlagActive)
    });
  }

  get MasterCode() { return this.masterForm.get('MasterCode'); }
  get MasterName() { return this.masterForm.get('MasterName'); }
  
  async LoadLookupType(LookupType) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = LookupType;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise();
    }
  }
  async LoadMasterList(dataId: number = 0): Promise<PositionLevelInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      objectjson['PositionLevelId'] = dataId;
      objectjson['PositionLevel'] = this.txtSchMasterCode;
      objectjson['MasterName'] = this.txtSchMasterName;
      objectjson['FlagActive'] = $('#ddlSchMasterStatus').val();
      objectjson['rowFetch'] = environment.PageSizeMedium;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<PositionLevelInfo[]>(this.baseurl + "Position/GetPositionLevelList", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCountMasterList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['PositionLevel'] = this.txtSchMasterCode;
      objectjson['MasterName'] = this.txtSchMasterName;
      objectjson['FlagActive'] = $('#ddlSchMasterStatus').val();
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<number>(this.baseurl + "Position/GetCountPositionLevelList", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SetTotalpagePagination(data);
        });
    }
  }

  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = true;
    this.LoadMasterList().then((data) => {
      this.ListMasterManagement = data;
    });
  }
  OnClear_Click() {
    this.txtSchMasterCode = null;
    this.txtSchMasterName = null;
    $('#ddlSchMasterStatus').val('')

    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = false;
    this.LoadMasterList().then((data) => {
      this.ListMasterManagement = data;
    });
  }

  //Create btn
  OnCreatePosition_Click() {

    $('#modalCreateMasterTitle').html('Create Position');
    $('#modalCreateOrEditMaster').modal();
    this.positionInfo = new PositionLevelInfo;
    this.MasterCode.setValue(null);
    this.MasterName.setValue(null);

    this.masterForm.markAsUntouched();
    this.masterForm.markAsPristine();
  }

  async OnSubmitCreatePosition_Click() {
    if (this.masterForm.valid && !this.IsDuplicateCode) {
      this.Loading(true, 'Creating...');

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.masterForm.value;
        
        objectjson['PositionLevel'] = this.masterForm.get('MasterCode').value;
        objectjson['PositionLevelName'] = this.masterForm.get('MasterName').value;
        objectjson['FlagActive'] = this.masterForm.get('MasterStatus').value;
        objectjson['CreateBy'] = this._EmpCode;

        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "Position/InsertPositionLevelManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            this.titlemodal = '';
            this.detailmodal = 'Position level has been created successfully.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-gold');
            $('#ModalComplate').modal();
            $('#modalCreateOrEditMaster').modal('hide');
            setTimeout(() => { this.Loading(false, ''); }, 500);

            //Reload
            this.LoadMasterList().then((data) => {
              this.ListMasterManagement = data;
            });
            this.LoadCountMasterList();
          });
      }
    } else {
      this.markFormGroupTouched(this.masterForm);
    }

  }
  async OnEdit_Click(masterId) {


    if (!!masterId) {
      this.Loading(true, 'Loading...');

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadMasterList(masterId).then((data) => {

          this.positionInfo = data[0];
          this.MasterCode.setValue(data[0].PositionLevel);
          this.MasterName.setValue(data[0].PositionLevelName);
          
          setTimeout(() => {
            this.Loading(false, '');
            $('#modalCreateMasterTitle').html('Edit Sale Team');
            $('#modalCreateOrEditMaster').modal();
          }, 500);
        });
      }
    }
  }
  async OnSubmitEdit_Click() {
    if (this.masterForm.valid && !this.IsDuplicateCode) {
      this.Loading(true, 'Save changes...');

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        //ปรับ flag ก่อนนำไป save ลง DB
        var objectjson = this.masterForm.value;
        objectjson['PositionLevel'] = this.masterForm.get('MasterCode').value;
        objectjson['PositionLevelName'] = this.masterForm.get('MasterName').value;
        objectjson['FlagActive'] = this.masterForm.get('MasterStatus').value;

        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['PositionLevelId'] = this.positionInfo.PositionLevelId;
        

        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "Position/UpdatePositionLevelManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.titlemodal = '';
              this.detailmodal = 'Position level has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();
              $('#modalCreateOrEditMaster').modal('hide');
              setTimeout(() => { this.Loading(false, ''); }, 500);

              //Reload
              this.LoadMasterList().then((data) => {
                this.ListMasterManagement = data;
              });
            } else {
              this.titlemodal = 'Fail.';
              this.detailmodal = 'Position was updated fail.';
              $('#ModalError').modal();
              $('#modalCreateOrEditMaster').modal('hide');
              setTimeout(() => { this.Loading(false, ''); }, 500);

            }
          });
      }
    } else {
      this.markFormGroupTouched(this.masterForm);
    }
  }
  async OnDelete_Click(masterId) {
    if (!!masterId) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.Loading(true, 'Deleting...');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.masterForm.value;
        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['PositionLevelId'] = masterId;

        let arrjson: PositionLevelInfo[] = [];
        arrjson.push(objectjson);
        let strjson = JSON.stringify(arrjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "Position/DeletePositionLevelManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.isSearchSubmitted = false;
              this.titlemodal = '';
              this.detailmodal = 'Position level has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              setTimeout(() => { this.Loading(false, ''); }, 500);

              //Reload
              this.LoadMasterList().then((data) => {
                this.ListMasterManagement = data;
              });

            }
            else {

              this.titlemodal = 'Fail.';
              this.detailmodal = 'Delete fail.';
              $('#ModalError').modal();

              setTimeout(() => { this.Loading(false, ''); }, 500);

            }
          });
      }
    }
  }
  async OnDeleteList_Click() {
    if (confirm("Are you sure to delete these position?")) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var listDeleteChecked = $('[name="checkboxdelete"]:checked');
        let arrjson: PositionLevelInfo[] = [];

        //เก็บ List id ที่จะ delete
        $.each(listDeleteChecked, function (idx, val) {

          var curId = $(val).data('positionid');
          var model = new PositionLevelInfo;
          model.PositionLevelId = curId;
          arrjson.push(model);
        });

        //ส่งไป Delete
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        let strjson = JSON.stringify(arrjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "Position/DeletePositionLevelManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {

              this.titlemodal = '';
              this.detailmodal = 'Position levels have been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              setTimeout(() => {
                this.Loading(false, '');
                this.isSearchSubmitted = false;
                //Reload
                this.LoadMasterList().then((data) => {
                  this.ListMasterManagement = data;
                });
                this.LoadCountMasterList()
              }, 500);


            }
            else {

              this.titlemodal = 'Fail.';
              this.detailmodal = 'Delete fail.';
              $('#ModalError').modal();

              setTimeout(() => { this.Loading(false, ''); }, 500);
            }
          });
      }
    }
  }

  //Name position clicked
  async OnAddRights_Click(positionId) {
    if (!!positionId) {
      this.Loading(true, 'Loading...');

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadMasterList(positionId).then((data) => {

          this.positionInfo = data[0];
          this.MasterCode.setValue(data[0].PositionLevel);
          this.MasterName.setValue(data[0].PositionLevelName);
          
          setTimeout(() => {
            this.Loading(false, '');
            $('#modalCreateMasterTitle').html('Edit position level');
            $('#modalCreateOrEditMaster').modal();
          }, 500);
        });
      }
    }
  }
  async CheckDuplicateCode() {
    
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['PositionLevel'] = this.MasterCode.value;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<boolean>(this.baseurl + "Position/CheckDuplicatePositionLevelCode", strjson, httpOptions)
        .toPromise()
        .then(data => {

          this.IsDuplicateCode = data;

        })
        .catch(err => {

          this.IsDuplicateCode = false;

        });
    }
  }

  //Pagination
  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
      this.indexNo = traget.index;
    }

    this.LoadMasterList().then((data) => {
      this.ListMasterManagement = data;
    });;
  }
  SetTotalpagePagination(data) {
    this.totalMaster = data;
    if (this.totalMaster == 0) {
      this.currentPageNumber = 0;
    }
    this.totalPages = Math.ceil(this.totalMaster / environment.PageSizeMedium);
  }

  //Private function
  private Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();


      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}

